import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import userService from '../../services/userService';
import userActions from '../../actions/userActions';
import { useHistory } from 'react-router';
import { userIsSetSelector } from '../../selectors/userSelectors';
import Navbar from '../Navbar/Navbar';
import { useLocation } from 'react-router-dom';
import ws from '../../services/ws';
import api from '../../services/api';
import { ActionCableProvider } from '../Shared/ActionCable';

const handleCurrentUser = ({ dispatch }) => {
  api.pauseTracking((resumeTracking) => {
    userService
      .current()
      .then(({ data }) => dispatch(userActions.set(data)))
      .catch(() => dispatch(userActions.set(false)));

    resumeTracking();
  });
};

const Content = ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const userIsSet = useSelector(userIsSetSelector);

  const hiddenNavbarRoutePaths = ['/signup/welcome', '/confirm-account'];

  const showNavbar = useMemo(
    () => userIsSet && !hiddenNavbarRoutePaths.includes(location.pathname),
    [userIsSet, location, location?.pathname, hiddenNavbarRoutePaths],
  );

  useEffect(() => {
    handleCurrentUser({ dispatch });

    history.listen(() => {
      handleCurrentUser({ dispatch });
    });
  }, []);

  useEffect(() => {
    if (userIsSet) {
      const userPing = setInterval(
        () => handleCurrentUser({ dispatch }),
        60000,
      );

      return () => {
        window.clearInterval(userPing);
      };
    }
  }, [userIsSet, dispatch]);

  return (
    <div>
      <ActionCableProvider url={ws.connectionUrl()}>
        <LoadingIndicator />
        {showNavbar && <Navbar />}

        {children}
      </ActionCableProvider>
    </div>
  );
};

export default Content;
